import * as moment from "moment";
import * as React from "react";
import * as styles from "./styles.css";
import NewsList from "../../components/newsList";
import { getImgixUrl } from "../../utils/getImgixUrl";
export var LatestPosts = function (_a) {
    var posts = _a.posts;
    return (React.createElement("div", null,
        React.createElement(NewsList, { newsItems: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryLink: "/blog/category/" + post.categories[0].slug,
                link: "/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                size: "small",
                thumbnail: getImgixUrl(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=80&h=80&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=80&h=80&q=72"),
                title: post.title,
            }); }), styleOverride: styles.latestPosts })));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/latestPosts/index.tsx
// module id = gWW/
// module chunks = 3